import React, { useState } from "react";
import Carousel from "./Carousel";
import FeeTable from "./components/FeeTable";
import RegistrationDetails from "./components/RegistrationDetails";

const Registration = () => {
  const [showHotels, setShowHotels] = useState(false);

  const hotels = [
    {
      name: "Marasa Sarovar",
      link: "https://www.sarovarhotels.com/marasa-sarovar-premiere-tirupati-hotels/",
      travelTime: "45 min",
    },
    {
      name: "Ekante Bliss",
      link: "https://www.seleqtionshotels.com/en-in/hotels/ekante-bliss-tirupati/",
      travelTime: "40 min",
    },
    {
      name: "Golden Tulip",
      link: "https://www.sarovarhotels.com/golden-tulip-tirupati/",
      travelTime: "45 min",
    },
    {
      name: "Starlit Suites",
      link: "https://www.starlitsuites.com/tirupati/",
      travelTime: "40 min",
    },
    {
      name: "Kences Tirupati",
      link: "https://kenceshotel.com/",
      travelTime: "40 min",
    },
    {
      name: "Fortune Select Grand Ridge",
      link: "https://www.itchotels.com/in/en/fortuneselectgrandridge-tirupati/",
      travelTime: "35 min",
    },
    {
      name: "Republic Inn",
      link: "https://republicinn.in/",
      travelTime: "40 min",
    },
    {
      name: "MGM Grand, Srikalahasti",
      link: "https://www.hotelmgmgrand.in/",
      travelTime: "25 min",
    },
  ];

  return (
    <>
      <Carousel img="bg6.jpg" />
      <hr />
      <div className="container py-5">
        <h1 className="text-center mb-4">Registration</h1>

        <div className="mb-4">
          <p className="fw-bold">
            Registration/ attendance for any events of the “Indian Lean
            Construction Conference 2025 (ILCC2025)” implicitly assumes complete
            acceptance of the Terms and Conditions of ILCC2025:
          </p>
          <p>
            Registration or attendance at ILCC 2025 constitutes full acceptance
            of the conference’s official Terms and Conditions.
          </p>
          <ol>
            <li>
              Authors of accepted papers or posters are required to sign a
              Copyright Transfer Form for each submission. These forms are
              available on the Submissions page, and any paper or poster without
              a signed form will not be published or included in the conference
              schedule.
            </li>
            <li>
              To ensure inclusion in the program, at least one full Conference
              Day registration on December 2 or must be completed for every two
              accepted papers or posters an attendee is listed on as an author.
            </li>
          </ol>
          <p className="text-danger fw-bold">
            NOTE: Given limited seats for Workshop day, First come - first serve
            principle may be applied for registrations.
          </p>
        </div>

        <div className="text-center mb-4">
          <a
            href="https://forms.gle/RpBpg7Rsu3WaveEW9"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-lg fw-bold"
          >
            Click here for the Registration
          </a>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-light">
              <tr>
                <th>Delegation Category</th>
                <th>
                  Workshop Day
                  <br />
                  (Nov 30)
                </th>
                <th>
                  Industry Day
                  <br />
                  (Dec 1)
                </th>
                <th>
                  Conference Day
                  <br />
                  (Dec 2 & 3)
                </th>
                <th>All 4 Days</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ILCE MEMBER - Chartered/ Corporate/ Associate</td>
                <td>Rs. 5570</td>
                <td>Rs. 5570</td>
                <td>Rs. 11140</td>
                <td>Rs. 22279</td>
              </tr>
              <tr>
                <td>ILCE MEMBER - Individual</td>
                <td>Rs. 4874</td>
                <td>Rs. 4874</td>
                <td>Rs. 9747</td>
                <td>Rs. 19494</td>
              </tr>
              <tr>
                <td>Non - Member</td>
                <td>Rs. 6266</td>
                <td>Rs. 6266</td>
                <td>Rs. 12532</td>
                <td>Rs. 25064</td>
              </tr>
              <tr>
                <td>IITT Alumni/ Faculty</td>
                <td>Rs. 2089</td>
                <td>Rs. 2089</td>
                <td>Rs. 4178</td>
                <td>Rs. 8355</td>
              </tr>
              <tr>
                <td>Student of any recognized Institution</td>
                <td>Rs. 1393</td>
                <td>Rs. 1393</td>
                <td>Rs. 2785</td>
                <td>Rs. 5570</td>
              </tr>
              <tr>
                <td>Faculty of any recognized Institution</td>
                <td>Rs. 2437</td>
                <td>Rs. 2437</td>
                <td>Rs. 4874</td>
                <td>Rs. 9747</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="fw-bold">Registration fee is inclusive of GST</p>

        <div className="mt-5">
          <h5>Refund and Cancellations</h5>
          <p>
            If a registrant is unable to attend an event for any reason they may
            substitute, by arrangement with the Organisers who would require
            valid justification for the change, someone else from the same
            institute/organisation, provided the request is made before 1st
            November 2025. However, if an author of an accepted paper/ poster
            transfers his/her registration to another person who is not a
            co-author of that paper/ poster, then he/she loses the presentation
            slot for that paper/ poster.
          </p>
          <p>
            If the registrant is unable to attend, and is not in a position to
            transfer his/her place to another person or to another event, please
            note that none of the payments will be refunded.
          </p>
          <p>
            <strong>
              All dispute resolution is subject to Tirupati Jurisdiction.
            </strong>
          </p>
        </div>

        {/* Accommodation Toggle */}
        <div className="text-center mt-5">
          <button
            className="btn btn-outline-primary"
            onClick={() => setShowHotels(!showHotels)}
          >
            {showHotels
              ? "Hide Accommodation"
              : "Accommodation Options within Tirupati"}
          </button>
        </div>

        {showHotels && (
          <div className="mt-4">
            <h4 className="text-center mb-3">Accommodation Options</h4>
            <ul className="list-group list-group-flush">
              {hotels.map((hotel, index) => (
                <li
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                >
                  <div>
                    <span className="fw-bold">{hotel.name}</span>
                    <br />
                    <small className="text-muted">
                      Travel time to conference venue: {hotel.travelTime}
                    </small>
                  </div>
                  <a
                    href={hotel.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-success"
                  >
                    Visit Website
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default Registration;